"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.App = void 0;
const react_1 = __importDefault(require("react"));
const host_context_provider_1 = require("./host-context-provider");
const runner_status_monitor_1 = require("./runner-status-monitor");
const iframe_container_loader_1 = require("./IframeContainer/iframe-container-loader");
const app_module_css_1 = __importDefault(require("./app.module.css"));
const App = ({ messageLog, options, children, ...props }) => {
    return (react_1.default.createElement(host_context_provider_1.HostContextProvider, { ...props },
        react_1.default.createElement(runner_status_monitor_1.RunnerStatusMonitor, { strict: process.env.TEST_MODE !== 'dev' },
            react_1.default.createElement(iframe_container_loader_1.IframeContainerLoader, { bucketUrl: options.bucketUrl, statusKeepAliveTimeoutMs: options.chunkStatusKeepAliveTimeoutMs, invisibleContainerClassName: app_module_css_1.default['iframe-container-invisible'], containerClassName: app_module_css_1.default['iframe-container'], invisibleIframeClassName: app_module_css_1.default['frame-invisible'], visibleIframeClassName: app_module_css_1.default.frame }))));
};
exports.App = App;
